import React, { useState, useEffect } from 'react';
import axios from '../helpers/axiosConfig';
import { toast } from 'react-toastify';

const ListeBoaDss = () => {
  const [boadss, setBoaDss] = useState([]);

  const fetchBoaDss = async () => {
    try {
      const response = await axios.get('/boadss');
      setBoaDss(response.data);
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };
  useEffect(() => {
    fetchBoaDss();
  }, []);

  return (
    <div className="container mt-4">
      <div className="alert alert-warning p-1 ">
        <h2>Liste Boa et Dss</h2>
      </div>
      <table className="table table-striped">
        <thead className="thead-dark">
          <tr>
            <th>#</th>
            <th>Bataillon ou DSS</th>
            <th>Corps Unités</th>
            <th>Observation</th>
            <th>Zone de Défense</th>
          </tr>
        </thead>
        <tbody>
          {boadss.length === 0 ? (
            <tr>
              <td colSpan="5" className="text-center">
                Aucun enregistrement trouvé
              </td>
            </tr>
          ) : (
            boadss.map((boa, index) => (
              <tr key={boa.id}>
                <td>{index + 1}</td>
                <td>{boa.bataillonoudss}</td>
                <td>{boa.corpsunites}</td>
                <td>{boa.observation}</td>
                <td>{boa.zonededefense ? boa.zonededefense.name : 'Non défini'}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ListeBoaDss;
